import nhtsaVehicleTypes from "@lib/nhtsa-vehicle-types";

export const iconSize = 60;

export const validManufacturers = [
  "HARLEY-DAVIDSON DO BRASIL LTDA",
  "HARLEY-DAVIDSON MOTOR COMPANY",
  "HARLEY-DAVIDSON OFF-ROAD",
  "BUELL MOTORCYCLE CO.",
].map((m) => m.toLowerCase());

export function nhtsaMakeIsValid(results, allowAllVendors = true) {
  if (!results || JSON.stringify(results) === "{}") return false;
  const make = results
    .find((result) => result.Variable === "Make")
    ?.Value?.toLowerCase();

  const manufacturer = results
    .find((result) => result.Variable === "Manufacturer Name")
    ?.Value?.toLowerCase();

  const validMakes = ["harley-davidson", "harley", "livewire", "buell"].map(
    (m) => m.toLowerCase()
  );

  if (!make && !manufacturer) {
    return true;
  }

  if (!make) {
    if (allowAllVendors) {
      return true;
    } else {
      return validManufacturers.includes(manufacturer);
    }
  }

  if (allowAllVendors) {
    return true;
  } else {
    return validMakes.includes(make);
  }
}

export function nhtsaTypeIsValid(
  results,
  validTypes = nhtsaVehicleTypes.map((m) => m.value)
) {
  if (!results || JSON.stringify(results) === "{}") return false;

  const vehicleType = results.find(
    (result) => result.Variable === "Vehicle Type"
  );

  if (!vehicleType) return false;

  return validTypes.includes(vehicleType.ValueId);

  if (!vehicleType || vehicleType.ValueId !== "1") return false;

  return true;

  // return validMakes.includes(make);
}

export function getDataFromNhtsaResults(results) {
  const baseProperties = [
    { key: "Make", text: "Make", server_key: "make" },
    { key: "Model", text: "Model", server_key: "model" },
    { key: "Model Year", text: "Year", server_key: "year" },
    { key: "Series", text: "Series", server_key: "series" },
    { key: "Vehicle Type", text: "Type", server_key: "vehicle_type" },
  ];

  if (JSON.stringify(results) === "{}" && results)
    return baseProperties.map((m) => ({
      ...m,
      value: "",
    }));

  return baseProperties
    .map((m) => {
      let resultValue = results?.find((f) => f.Variable === m.key)?.Value;
      if (m.key === "Make" && !resultValue) {
        const manufacturer = results
          ?.find((f) => f.Variable === "Manufacturer Name")
          ?.Value?.toLowerCase();

        if (manufacturer && validManufacturers.includes(manufacturer)) {
          resultValue = "HARLEY-DAVIDSON";
        }
      }
      return {
        ...m,
        value: resultValue || "",
      };
    })
    .filter((f) => (f.key === "Series" && !f.value ? false : true));
}
